import {useEffect} from "react";

/** Adds `.in` to every `.reveal` element as it scrolls into view. */
export const useReveal = () => {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>(".reveal"));
    if (!("IntersectionObserver" in window)) {
      els.forEach(el => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      {threshold: 0.12}
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
};
